const MaterialMovementsOperations = {
    options: [
        {label: "AJUSTE", value: 'adjustment'},
        {label: "AQUISIÇÃO", value: 'acquisition'},
        {label: "BAIXA", value: 'decrease'},
        {label: "CAUTELA", value: 'caution'},
        {label: "INDISPONIBILIDADE", value: 'maintenance_send'},
        {label: "RETORNO DE CAUTELA", value: 'caution_return'},
        {label: "RETORNO DE INDISPONIBILIDADE", value: 'maintenance_return'},
        {label: "TRANSFERÊNCIA", value: 'transfer'}
    ],

    findByLabel: (label) => {
        return MaterialMovementsOperations.options.find(o => o.label === label);
    },

    findByValue: (value) => {
        return MaterialMovementsOperations.options.find(o => o.value === value);
    }
};

export default MaterialMovementsOperations;
